/**
 * <arcero-product-card> — wires the size-strip buttons to the card's
 * shared add-to-cart form. Each size button (type="button", not submit)
 * sets the hidden variant-id input and triggers requestSubmit(); the
 * existing <product-form-component> intercepts the form's submit event
 * and performs the real AJAX add-to-cart (Horizon's own pipeline, not
 * reimplemented here). No confirmation animation, no external
 * dependencies.
 */
class ArceroProductCard extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.variantInput = this.querySelector('[data-arcero-variant-input]');

    if (!this.form || !this.variantInput) return;

    this.querySelectorAll('[data-arcero-size-button]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        this.variantInput.value = button.dataset.variantId;
        this.form.requestSubmit();
      });
    });
  }
}

customElements.define('arcero-product-card', ArceroProductCard);
